import { Routes, Route, Navigate } from 'react-router-dom'
import { Dashboard } from './components/Dashboard'
import { TokenSetup } from './components/TokenSetup'
import { DeviceFlowSetup } from './components/DeviceFlowSetup'
import { CastReceiver } from './components/CastReceiver'
import { hasToken } from './github'

export default function App() {
  return (
    <Routes>
      {/* Path por default sin PAT: Device Flow (cómodo en TV). PAT manual queda en /setup-pat. */}
      <Route path="/setup" element={<DeviceFlowSetup />} />
      <Route path="/setup-pat" element={<TokenSetup />} />
      {/* /cast/:session — el celular abre este path. No requiere PAT. */}
      <Route path="/cast/:session" element={<CastReceiver />} />
      <Route
        path="/"
        element={hasToken() ? <Dashboard /> : <Navigate to="/setup" replace />}
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
